import { g as getRoomType } from './get-room-type.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * D-Edge v2
 */
const factory = function factory({ window, document, thn }) {
    let onCheckoutSuccessEvent = null;
    let updatePriceOnDataLayerEvent = null;
    const languageToLocale = {
        id: '/id-ID/',
        ca: '/ca-ES/',
        cs: '/cs-CZ/',
        da: '/da-DK/',
        de: '/de-DE/',
        et: '/et-EE/',
        en: '/en-US/',
        es: '/es-ES/',
        fr: '/fr-FR/',
        hr: '/hr-HR/',
        is: '/is-IS/',
        it: '/it-IT/',
        lv: '/lv-LV/',
        lt: '/lt-LT/',
        hu: '/hu-HU/',
        ms: '/ms-MY/',
        nl: '/nl-NL/',
        nb: '/nb-NO/',
        pl: '/pl-PL/',
        pt: '/pt-PT/',
        ro: '/ro-RO/',
        sk: '/sk-SK/',
        sl: '/sl-SI/',
        sr: '/sr-Latn-RS/',
        fi: '/fi-FI/',
        sv: '/sv-SE/',
        vi: '/vi-VN/',
        tr: '/tr-TR/',
        el: '/el-GR/',
        bg: '/bg-BG/',
        ru: '/ru-RU/',
        uk: '/uk-UA/',
        he: '/he-IL/',
        th: '/th-TH/',
        ja: '/ja-JP/',
        ko: '/ko-KR/',
        zh: '/zh-CN/',
    };
    const roomDetailsParseData = (numAdults, numChildren) => {
        const roomsArray = Array.from(document.querySelectorAll('.cvg-room-card'));
        if (thn.empty(roomsArray)) {
            return [];
        }
        const roomsInfo = roomsArray.map((room) => {
            const roomName = room.querySelector('.cvg-room-card__content-tile')?.textContent?.trim();
            const roomType = getRoomType(roomName);
            const ratesInfo = Array.from(room.querySelectorAll('.cvg-rate-card')).map((rate) => {
                const rateName = rate.querySelector('.cvg-rate-card__presentation-title h3')?.textContent?.trim();
                const ratePrice = thn.parseNumber(rate.querySelector('.cvg-rate-card__price .cvg-typo-heading-3')?.textContent);
                const hasBreakfast = !!rateName?.match(/breakfast/i);
                const isRefundable = true;
                if (!rateName || !ratePrice) {
                    return null;
                }
                return {
                    name: rateName,
                    totalNight: ratePrice,
                    breakfast: hasBreakfast,
                    refundable: isRefundable,
                };
            }).filter((value) => value !== null);
            if (!roomName) {
                return null;
            }
            return {
                name: roomName,
                adults: numAdults || 2,
                children: numChildren || 0,
                type: roomType,
                rates: ratesInfo,
                prices: ratesInfo,
            };
        });
        return roomsInfo.filter((value) => value !== null);
    };
    return {
        languageCheck(ctx) {
            return new Promise((resolve, reject) => {
                const lang = thn.dataLayerHelper.get('context.language')
                    ?? window.location.pathname.match(/\/(\w{2})(?=\/|$)/)?.[1]
                    ?? document.documentElement.lang;
                if (lang && ctx.langs.test(lang)) {
                    resolve(lang);
                    return;
                }
                reject(new Error('no_language'));
            });
        },
        onStateChange: thn.debounce(() => {
            thn.languageCheck().catch(() => { });
            thn.pageCheck();
        }, 300),
        boot() {
            const container = document.querySelector('.gst-page-layout__main, #app');
            const indexContainer = document.querySelector('.global-wrapper');
            if (container) {
                const refreshPage = thn.debounce(() => {
                    thn.pageCheck();
                    thn.languageCheck().catch(() => { });
                }, 700);
                thn.observeDom(container, refreshPage, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                });
                thn.shutdown(() => {
                    refreshPage.cancel();
                    thn.stopObserveDom(container, refreshPage);
                });
            }
            if (indexContainer) {
                const refreshPageIndex = thn.debounce(() => {
                    if (thn.isVisible(document.querySelector('.booking_wrapper')) && thn.data.accountUserId === 1046065) {
                        thn.pageCheck();
                    }
                }, 500);
                thn.observeDom(indexContainer, refreshPageIndex, {
                    childList: true,
                    attributes: true,
                });
                thn.shutdown(() => {
                    refreshPageIndex.cancel();
                    thn.stopObserveDom(indexContainer, refreshPageIndex);
                });
            }
        },
        generateSearchUrl(ctx) {
            const url = new URL(ctx.baseUrl);
            const validUrl = url.hostname.match(/secure-hotel-booking/);
            // https://www.secure-hotel-booking.com/d-edge/The-Independente-Hostel-Suites/JSHW/en/RoomSelection?arrivalDate=2024-06-17&departureDate=2024-06-19&selectedAdultCount=2&selectedChildCount=0&selectedInfantCount=1
            if (!validUrl) {
                ctx.newUrl = '';
                return ctx;
            }
            const langRegex = /\/[a-zA-Z]{2}-[a-zA-Z]{2}\//;
            const langPath = languageToLocale[ctx.data.language] ?? '/en-US/';
            if (langPath) {
                url.pathname = url.pathname.replace(langRegex, langPath);
            }
            url.searchParams.set('arrivalDate', '[date_begin]');
            url.searchParams.set('departureDate', '[date_end]');
            url.searchParams.set('selectedAdultCount', '[adults]');
            const childrenAges = ctx.data?.roomsDispo?.[0]?.childrenAges ?? [];
            let infants = 0;
            let children = 0;
            for (let i = 0; i < childrenAges.length; i += 1) {
                if (childrenAges[i] < 2) {
                    infants += 1;
                }
                else {
                    children += 1;
                }
            }
            url.searchParams.set('selectedChildCount', children.toString());
            url.searchParams.set('selectedInfantCount', infants.toString());
            ctx.newData.dateBegin = ctx.data.dateBegin?.replace(/\//g, '-');
            ctx.newData.dateEnd = ctx.data.dateEnd?.replace(/\//g, '-');
            ctx.newUrl = url.toString();
            return ctx;
        },
        priceObserveDom(ctx) {
            updatePriceOnDataLayerEvent = (data) => {
                const debouncedPriceRefresh = thn.debounce(() => ctx.widget.refresh(), 800);
                if (!data.message)
                    return;
                const message = data.message;
                if (message.event === 'virtual_page_view' || message.event_name === 'view_item_list' || message.event_name === 'search_completed') {
                    debouncedPriceRefresh()?.catch(() => { });
                }
            };
            thn.bus.on('dataLayer:push', updatePriceOnDataLayerEvent);
            thn.shutdown(() => {
                if (updatePriceOnDataLayerEvent) {
                    thn.bus.detach('dataLayer:push', updatePriceOnDataLayerEvent);
                }
                updatePriceOnDataLayerEvent = null;
            });
        },
        priceParseData() {
            // Guests, Adults & Children
            const guestsSelector = document.querySelector('.cvg-rate-card__presentation__icon')?.textContent;
            const guestsArray = guestsSelector?.match(/\d+/g)?.map((guest) => thn.parseNumber(guest)) ?? [];
            let adults = thn.dataLayerHelper.get('search_parameters.adult_count');
            let children = thn.dataLayerHelper.get('search_parameters.children_count');
            let infants = thn.dataLayerHelper.get('search_parameters.infant_count');
            if (!thn.empty(guestsArray)) {
                adults = guestsArray[0] || 2;
                children = guestsArray[1] || 0;
                infants = guestsArray[2] || 0;
            }
            const roomInfo = {
                adults: Number(adults) ?? 2,
                children: Number(children) + Number(infants),
                childrenAges: [],
            };
            for (let i = 1; i <= roomInfo.children; i += 1) {
                roomInfo.childrenAges.push(i < roomInfo.children ? 10 : 1);
            }
            // Dates
            const dateBegin = thn.dataLayerHelper.get('search_parameters.checkin_date')?.replace(/-/g, '/');
            const dateEnd = thn.dataLayerHelper.get('search_parameters.checkout_date')?.replace(/-/g, '/');
            if (!dateBegin || !dateEnd) {
                return null;
            }
            const nights = thn.daysBetween(dateBegin, dateEnd) ?? 0;
            // Prices & Currency || No Rooms
            const pricesEls = Array.from(document.querySelectorAll('div[class*=rate-card__price]>div'))
                .concat(Array.from(document.querySelectorAll('div[class$=starting-price]')));
            const prices = pricesEls.map((price) => thn.parseNumber(price?.textContent))
                .filter((value) => typeof value !== 'undefined');
            const currency = thn.dataLayerHelper.get('search_parameters.search_currency');
            const noAvailability = document.querySelector('.cvg-rooms .gst-banner--variation-brand');
            const hotelDividePricesByNights = !!pricesEls?.[0]?.textContent?.match(/night|malam|nit|nit|noc|nætter|Übernachtung|ööd|noche|nuit|noćenja|nætur|naktis|nakvynės|éjszaka|malam|nacht|natt|noc|noite|innoptari|noci|noči|noćenje|yö|nätter|đêm|gece|διανυκτέρευση|нощувка|לילה|ніч|ليلة|คืน|숙박일|晚|泊/i);
            const price = hotelDividePricesByNights ? Math.min(...prices) : Math.min(...prices) / nights;
            if (!thn.empty(prices) && currency && nights) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo: [roomInfo],
                    roomDetails: roomDetailsParseData(roomInfo.adults, roomInfo.children),
                    price,
                    currency,
                };
            }
            if (noAvailability) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo: [roomInfo],
                    noRooms: true,
                };
            }
            return null;
        },
        getPromocode(ctx) {
            const codeValue = thn.dataLayerHelper.get('search_parameters.promotion_id');
            if (codeValue) {
                ctx.promocode = codeValue;
            }
            return ctx;
        },
        bookingObserveDom(ctx) {
            if (ctx.widget.isSet() || onCheckoutSuccessEvent) {
                return;
            }
            onCheckoutSuccessEvent = (data) => {
                if (!data.message)
                    return;
                const message = data.message;
                if ((message?.event === 'TransactionCompleted' || message?.event === 'ecommerce_event') && ctx.widget.setData().isSet()) {
                    ctx.widget.save();
                    if (onCheckoutSuccessEvent) {
                        thn.bus.detach('dataLayer:push', onCheckoutSuccessEvent);
                        onCheckoutSuccessEvent = null;
                    }
                }
            };
            thn.bus.on('dataLayer:push', onCheckoutSuccessEvent, true);
            thn.pageUnload(() => {
                if (onCheckoutSuccessEvent) {
                    thn.bus.detach('dataLayer:push', onCheckoutSuccessEvent);
                    onCheckoutSuccessEvent = null;
                }
            });
        },
        bookingParseData() {
            const bookingId = thn.dataLayerHelper.get('booking.reference') || thn.dataLayerHelper.get('booking.booking_reference') || thn.parseUrlParameter('bookingReference');
            if (!bookingId) {
                return {
                    set: false,
                };
            }
            // Dates of reservation for latest version of D-Edge doesn't appear on the dataLayer
            const datesSelector = document.querySelector('.booking-recap__dates')?.textContent?.trim().split('to') ?? [];
            const checkinDate = datesSelector?.[0] ? translateDate(datesSelector[0]?.replace(/From/, '')?.trim(), thn.data.language) : '';
            const checkoutDate = datesSelector?.[1] ? translateDate(datesSelector[1]?.trim(), thn.data.language) : '';
            const dateBegin = thn.dataLayerHelper.get('booking.checkinDate')?.replace(/-/g, '/') || checkinDate;
            const dateEnd = thn.dataLayerHelper.get('booking.checkoutDate')?.replace(/-/g, '/') || checkoutDate;
            const price = thn.dataLayerHelper.get('booking.transaction.total.totalPrice.invoiced') || thn.dataLayerHelper.get('booking.total_price');
            const currency = thn.dataLayerHelper.get('transaction.currency') || thn.dataLayerHelper.get('items')?.[0]?.currency;
            const promocode = thn.dataLayerHelper.get('transaction.coupon') || document.querySelector('.basket-discount')?.textContent?.trim().split(':')?.[1].trim();
            return {
                bookingId,
                dateBegin,
                dateEnd,
                price,
                currency,
                promocode,
            };
        },
    };
};

export { factory };
